const ToggleSwitch = ({ checked, onChange, labelOn = "On", labelOff = "Off" }) => {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-semibold transition-all duration-200 ${
        checked
          ? "bg-emerald-50 border-emerald-200 text-emerald-700"
          : "bg-gray-50 border-gray-200 text-gray-600"
      }`}
      aria-pressed={checked}
    >
      <span
        className={`w-3 h-3 rounded-full transition-all duration-200 ${
          checked ? "bg-emerald-500" : "bg-gray-400"
        }`}
      />
      {checked ? labelOn : labelOff}
    </button>
  );
};

export default ToggleSwitch;

